module.exports = __webpack_public_path__ + "static/media/3.f2e970cc.JPG";